import { render, staticRenderFns } from "./createBom.vue?vue&type=template&id=4bb3e001&scoped=true&"
import script from "./createBom.vue?vue&type=script&lang=js&"
export * from "./createBom.vue?vue&type=script&lang=js&"
import style0 from "./createBom.vue?vue&type=style&index=0&id=4bb3e001&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3e001",
  null
  
)

export default component.exports